import { call, put, all, takeEvery } from 'redux-saga/effects';
import axiosInstance from 'utils/axiosUtil';
import { API_PROVIDER_COMMENTS_GET } from '../actions/providerCommentsActions';

function uniqById(arr) {
  const seen = new Set();
  return (arr || []).filter((item) => {
    if (!item || typeof item.id === 'undefined') return false;
    if (seen.has(item.id)) return false;
    seen.add(item.id);
    return true;
  });
}

function* fetchProviderComment(action) {
  const commentId = action.id;
  try {
    // 1. Fetch main ProviderComment with "user" association only
    const { data: commentArr } = yield call(axiosInstance.get, '/ProviderComments', {
      params: {
        opts: {
          where: { id: { $eq: commentId } },
          include: [{
            association: 'user',
            attributes: ['id', 'first_name', 'last_name'],
          }]
        }
      }
    });
    const comment = commentArr && commentArr[0];
    if (!comment) {
      yield put({
        type: API_PROVIDER_COMMENTS_GET + '_FAILURE',
        id: commentId,
        error: 'Not found',
      });
      return;
    }

    // 2. Fetch all associated entities in parallel
    const [
      providersRes,
      contactsRes,
      documentsRes,
      tagsRes,
      locationsRes
    ] = yield all([
      call(axiosInstance.get, `/ProviderComments/${commentId}/providers`),
      call(axiosInstance.get, `/ProviderComments/${commentId}/contacts`),
      call(axiosInstance.get, `/ProviderComments/${commentId}/documents`),
      call(axiosInstance.get, `/ProviderComments/${commentId}/tags`),
      call(axiosInstance.get, `/ProviderComments/${commentId}/locations`)
    ]);

    // 3. Populate associations & deduplicate
    comment.providers = uniqById(providersRes.data?.[0]?.providers ?? []);
    comment.contacts = uniqById(contactsRes.data?.[0]?.contacts ?? []);
    comment.documents = documentsRes.data?.[0]?.documents ?? [];
    comment.tags = uniqById(tagsRes.data?.[0]?.tags ?? []);
    comment.locations = uniqById(locationsRes?.data[0]?.locations ?? []);

    yield put({
      type: API_PROVIDER_COMMENTS_GET + '_SUCCESS',
      id: commentId,
      response: comment,
      meta: { requestAction: action },
    });

  } catch (error) {
    console.log(error);
    yield put({
      type: API_PROVIDER_COMMENTS_GET + '_FAILURE',
      id: commentId,
      error: error.message || error,
      meta: { requestAction: action },
    });
  }
}

// Watcher
export function* watchProviderCommentDetail() {
  yield takeEvery(API_PROVIDER_COMMENTS_GET, fetchProviderComment);
}
